import apiFetch from '../apiFetch'
export default function (rfc, organizedUnitId, token) {
  return apiFetch({ endPoint: `entityByRFC?rfc=${rfc}&organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
